export const EVENTS = {
  UPDATE_HP: 'update-hp',
};
